import { CLEAN_EDIT_LEGAL_DATA, CLEAN_EDIT_LEGAL_DATA_ERROR } from '_models/redux/types';

export const cleanEditLegalData = () => async (dispatch) => {
  try {
    dispatch({
      type: CLEAN_EDIT_LEGAL_DATA,
      payload: [],
    });
  } catch (e) {
    dispatch({
      type: CLEAN_EDIT_LEGAL_DATA_ERROR,
      payload: [],
    });
  }
};
